import { ChangeEventHandler, FunctionComponent, useCallback } from 'react'

import { useQueryClient } from '@tanstack/react-query'
import styled from 'styled-components'

import { updateUserTheme, UserThemeNonServer } from '@utils/theme'
import translate from '@i18n'
import useTracking from '@hooks/useTracking'
import useUserTheme from '@hooks/useUserTheme'
import {
  DarkModeTrackingValueType,
  displayClickHandler,
} from '@widgets/UserProfile/tracking'
import SegmentedButton from '@components/Buttons/SegmentedButton'

const StyledSegmentedButton = styled(SegmentedButton)`
  width: 100%;
`

const ThemeSwitcher: FunctionComponent = () => {
  const queryClient = useQueryClient()
  const userTheme = useUserTheme()
  const handleThemeTrack = useTracking(displayClickHandler)

  const onThemePreferenceChange = useCallback<
    ChangeEventHandler<HTMLInputElement>
  >(
    (e) => {
      const value = e.target.value
      handleThemeTrack({
        mode: (value === 'auto'
          ? 'system'
          : `${value}_mode`) as DarkModeTrackingValueType,
      })
      updateUserTheme(queryClient, value as UserThemeNonServer)
    },
    [queryClient, handleThemeTrack],
  )

  const options = [
    { label: translate('userProfilePage.lightTheme'), value: 'light' },
    { label: translate('userProfilePage.darkTheme'), value: 'dark' },
    { label: translate('userProfilePage.autoTheme'), value: 'auto' },
  ]

  return (
    <StyledSegmentedButton
      options={options}
      value={userTheme}
      onChange={onThemePreferenceChange}
    />
  )
}

export default ThemeSwitcher
